var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeTotalstudents(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.819,
    height: 44.819,
    viewBox: "0 0 44.819 44.819",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_profile-2user",
    "data-name": "vuesax/bulk/profile-2user",
    transform: "translate(-172 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-2user",
    transform: "translate(172 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.87,0a8.862,8.862,0,0,0-.224,17.722,1.506,1.506,0,0,1,.411,0h.131A8.864,8.864,0,0,0,8.87,0Z",
    transform: "translate(7.937 3.735)",
    fill: "#387f75",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M22.633,2.605c-5.21-3.473-13.707-3.473-18.955,0C1.307,4.192,0,6.34,0,8.637s1.307,4.426,3.66,5.995a17.254,17.254,0,0,0,9.487,2.633,17.254,17.254,0,0,0,9.487-2.633c2.353-1.587,3.66-3.716,3.66-6.032A7.353,7.353,0,0,0,22.633,2.605Z",
    transform: "translate(3.66 23.819)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M10.981,6.132a6.684,6.684,0,0,1-5.845,7.227H5.042a.874.874,0,0,0-.317.037A6.7,6.7,0,0,1,0,11.846a8.546,8.546,0,0,0,2.8-7.1A8.666,8.666,0,0,0,1.363.679a6.7,6.7,0,0,1,9.617,5.453Z",
    transform: "translate(26.35 7.575)",
    fill: "#387f75",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M14.94,7.639a5.687,5.687,0,0,1-3.249,4.445A13.181,13.181,0,0,1,5.135,13.54,6.666,6.666,0,0,0,7.414,9.207,7.358,7.358,0,0,0,4.3,2.9,15.416,15.416,0,0,0,0,.542C4.127-.653,9.319.15,12.512,2.727A5.674,5.674,0,0,1,14.94,7.639Z",
    transform: "translate(26.126 23.342)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H44.819V44.819H0Z",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeTotalstudents);
export default __webpack_public_path__ + "static/media/home-totalstudents.f2f750dac795465b10e855f78cdd43ea.svg";
export { ForwardRef as ReactComponent };